<template>
	<v-dialog v-model="showDialog" max-width="600" persistent>
		<v-card>
			<v-card-title> Add Condition Field </v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-text-field
						label="Label"
						v-model="formConditionFields.Label"
						:rules="[(v) => !!v || 'Is required']"
					></v-text-field>
					<v-autocomplete
						:items="
							gridViewFields.sort((a, b) =>
								a.Label > b.Label ? 1 : -1
							)
						"
						v-model="formConditionFields.GridViewFieldIds"
						item-text="Label"
						item-value="Id"
						label="Group By Fields"
						:multiple="true"
						chips
						deletable-chips
						:rules="[(v) => !!(v && v.length) || 'Is required']"
					>
					</v-autocomplete>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-spacer />
				<v-btn color="primary" @click.stop="onSave">Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { ActivityDetailsGetters } from '../../../../store/getters';
import { ActivityDetailsActions } from '../../../../store/actions';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
export default {
	name: 'ActivityConditionFieldsModal',
	props: {
		showDialog: Boolean,
		selectedItem: Object,
	},
	computed: {
		...mapGetters({
			gridViewFields: [ActivityDetailsGetters.GRID_VIEW_FIELDS],
			hasItems: [ActivityDetailsGetters.HAS_ITEMS],
		}),
		formConditionFields() {
			return Object.assign({}, this.selectedItem);
		},
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onSave() {
			if (this.$refs.form.validate()) {
				if (this.hasItems) {
					ConfirmDialog({
						message:
							'Already created items will be deleted if group by criteria is modified. Do you want to continue?',
					}).then((isDelete) => {
						if (isDelete) {
							this.$store.dispatch(
								ActivityDetailsActions.DELETE_ALL_ACTIVITY_ITEMS_BY_ID,
								this.$route.params.id
							);
							if (this.formConditionFields.Id) {
								this.$store.dispatch(
									ActivityDetailsActions.UPDATE_CONDITION_FIELDS,
									this.formConditionFields
								);
							} else {
								this.formConditionFields.ActivityId =
									this.$route.params.id;
								this.$store.dispatch(
									ActivityDetailsActions.INSERT_CONDITION_FIELDS,
									this.formConditionFields
								);
							}
						}
					});
				} else {
					if (this.formConditionFields.Id) {
						this.$store.dispatch(
							ActivityDetailsActions.UPDATE_CONDITION_FIELDS,
							this.formConditionFields
						);
					} else {
						this.formConditionFields.ActivityId =
							this.$route.params.id;
						this.$store.dispatch(
							ActivityDetailsActions.INSERT_CONDITION_FIELDS,
							this.formConditionFields
						);
					}
				}
				this.$emit('close');
			}
		},
	},
};
</script>
